import Joi from 'joi';

export const AnnouncementSchema = Joi.object({
  title: Joi.string().required(),
  content: Joi.string().required(),
  pined: Joi.string().required(),
});

export const AnnouncementAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
